import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {
  MenuItem,
  FormControl,
  Select,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
//files
import CMOFilterMultiSelect from './CMOFilterMultiSelect';
import { useStyles } from './Styles';
import FromToDateFilter from './FromToDateFilter';
import SearchSelect from './SearchSelect';
import MFGPlantFilter from './MFGPlantFilter';

const Filter = (props) => {
  const classes = useStyles();
  const {
    cmoFilter,
    handleSelectCMO,
    selectedCMOList,
    productSearch,
    handleProductSearchQuery,
    startDate,
    endDate,
    handleDateChange,
    CMOMemberId,
    filterByCMOName,
    mfgPlantFilter,
    handleSelectMFGPlant,
    selectedMFGPlantList,
    setMFGPlantList,
    setAllMFGPlantList,
    filteredMFGPlantList,
    filteredCMOList,
    selectedSponsorIds,
    sponsorOrganizations,
    handleChangeSponsorList,
    getDisplaySponsorValue,
    handleSponsorClose,
  } = props;

  return (
    <Grid container spacing={2} style={{ alignItems: 'end' }}>
      {localStorage.collabType === "CMO" &&

        <Grid item xs={12} sm={6} md={2} style={{ alignItems: 'end' }}>
                        
       <Typography variant='body2' className={classes.filterField}>
         Sponsor:
       </Typography>
        <React.Fragment className={classes.filterFieldValue}>
       <FormControl
  className={classes.formControl}
  fullWidth
  >
       <Select
      size="small"
      multiple
      displayEmpty
      value={selectedSponsorIds}
      onChange={handleChangeSponsorList}
      onClose={handleSponsorClose}
      renderValue={getDisplaySponsorValue}
       variant='outlined'
       classes={{
            outlined: classes.outlined,
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
                overflowY: 'auto',
              },
            },
          }}
    >
      <MenuItem value="All">
        <Checkbox
          checked={
            sponsorOrganizations.length > 0 &&
            selectedSponsorIds.length === sponsorOrganizations.length
          }
        />
        <ListItemText primary="All" />
      </MenuItem>

      {sponsorOrganizations?.length>0 && (sponsorOrganizations.map((org) => (
        <MenuItem key={org.organizationId} value={org.organizationId}>
          <Checkbox
            checked={selectedSponsorIds.includes(org.organizationId)}
          />
          <ListItemText primary={org.organizationName} />
        </MenuItem>
      )))}
    </Select>
  </FormControl>
  </React.Fragment>
 </Grid>
           }
      
      {cmoFilter && (
        <Grid item xs={12} sm={6} md={2} style={{ alignItems: 'end' }}>
          <Typography variant='body2' className={classes.filterField}>
            CMO:
          </Typography>
          <CMOFilterMultiSelect
            handleSelectCMO={handleSelectCMO}
            selectedCMOList={selectedCMOList}
            filteredCMOList={filteredCMOList}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={2} style={{ alignItems: 'end' }}>
          <Typography variant='body2' className={classes.filterField}>
            MFG Plant:
          </Typography>
          <MFGPlantFilter
            handleSelectMFGPlant={handleSelectMFGPlant}
            selectedMFGPlantList={selectedMFGPlantList}
            setMFGPlantList={setMFGPlantList}
            setAllMFGPlantList={setAllMFGPlantList}
            filteredMFGPlantList={filteredMFGPlantList}
          />
      </Grid>
     
      <Grid item xs={12} sm={6} md={localStorage.collabType !== "Pharma Co" ? 2 : 3} style={{ alignItems: 'end' }}>
        <SearchSelect
         selectedSponsorIds={selectedSponsorIds}
          searchQuery={productSearch}
          handleSearchQuery={handleProductSearchQuery}
          CMOMember={CMOMemberId}
          selectedCMOList={selectedCMOList} 
          selectedMFGPlantList={selectedMFGPlantList}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} style={{ alignItems: 'end' }}>
        <FromToDateFilter
          startDate={startDate}
          endDate={endDate}
          handleDateChange={handleDateChange}
        />
      </Grid>
    </Grid>
  );
};

export default Filter;
